module.exports = __webpack_public_path__ + "static/media/19ESCAP32.e423d8a2.jpg";